import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initRoomCard() {
    const swiperContainers = document.querySelectorAll('.room-card__images');

    swiperContainers.forEach(container => {
        new Swiper(container, {
            modules: [Navigation],
            loop: true,
            slidesPerView: 1,
            speed: 600,
            navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev'),
            },
        });
    });

    // Parallax for room-card--full
    const fullRoomCards = document.querySelectorAll('.room-card--full');
    fullRoomCards.forEach(card => {
        const img = card.querySelector('.room-card__img img');
        if (!img) return;

        gsap.set(img, {
            scale: 1.15,
            yPercent: -10,
            transformOrigin: "center center"
        });

        gsap.to(img, {
            yPercent: 10,
            ease: 'none',
            scrollTrigger: {
                trigger: card,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
            }
        });
    });

    // Scroll animation for room-card--multiple
    let mm = gsap.matchMedia();

    mm.add("(min-width: 992px)", () => {
        const multipleRoomCards = document.querySelectorAll('.room-card--multiple');
        multipleRoomCards.forEach(component => {
            const items = component.querySelectorAll('.room-item');
            if (items.length < 2) return;

            gsap.to(items[1], {
                y: 100,
                duration: 1.2,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: component,
                    start: 'top 80%',
                    toggleActions: 'play none none none',
                }
            });
        });
    });
}
